import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const mergeTeamsRoute: InvariantJiraRoute = {
	name: 'eoc-merge-teams',
	path: '/jira/settings/products/ops/merge-teams',
	exact: true,
};
